import linkify from './linkify';
import atMention from './at-mention';

export default (activity, onEvent) => {
  const formatters = [linkify, atMention];
  let result = activity;

  formatters.forEach((formatter) => {
    result = formatter(result, onEvent);
  });

  return result;
};
